import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
const firebaseConfig = {
  apiKey: "AIzaSyAeZWcY4DXfeLSFF8t6RqKWgOBKi9Qs9qI",
  authDomain: "darts-tournament-56784.firebaseapp.com",
  projectId: "darts-tournament-56784",
  storageBucket: "darts-tournament-56784.firebasestorage.app",
  messagingSenderId: "676830188112",
  appId: "1:676830188112:web:bd629f11fd05e4305a7755"
};
// メインアプリ（通常ログイン用）
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
// Cloud Functions（メインappに紐づけ＝ログイン中のAdminトークンが乗る。regionはFunction側と一致）
export const functions = getFunctions(app, 'us-central1');
// Adminメールアドレス（このメアドでログインした人だけAdmin判定）
export const ADMIN_EMAILS = ['ikedasyk@gmail.com'];
